'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { Tooltip } from '@flipster/react/design-system-legacy/tooltip';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';

import { orderbookDataBunja } from './bunja';

export const OrderbookRatioBar = () => {
  const { bidAskRatioAtom } = useBunja(orderbookDataBunja);
  const { bidPercent, askPercent, isEmpty } = useAtomValue(bidAskRatioAtom);

  return (
    <Tooltip placement='top' shape='gray'>
      <Tooltip.Trigger>
        <div
          className={css({
            position: 'relative',
            h: 23,
            rounded: 4,
            overflow: 'hidden',
            mx: 16,
            mt: 16,
            cursor: 'default',
          })}
        >
          {/* Buy shape */}
          <div
            className={css({
              position: 'absolute',
              inset: 0,
              bg: isEmpty ? 'background.default.level-1' : 'background.state.positive.tint',
            })}
            style={{
              clipPath: `polygon(0 0, calc(${bidPercent}% - 1px) 0, calc(${Math.max(bidPercent - 4, 0)}% - 1px) 100%, 0 100%)`,
            }}
          />
          {/* Sell shape */}
          <div
            className={css({
              position: 'absolute',
              inset: 0,
              bg: isEmpty ? 'background.default.level-1' : 'background.state.negative.tint',
            })}
            style={{
              clipPath: `polygon(calc(${bidPercent}% + 1px) 0, 100% 0, 100% 100%, calc(${Math.max(bidPercent - 4, 0)}% + 1px) 100%)`,
            }}
          />
          {/* Buy label */}
          <div
            className={hstack({
              position: 'absolute',
              left: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              gap: 8,
              textStyle: 'Text/S/Monospace/Strong',
              color: isEmpty ? 'content.default.level-2' : 'content.state.positive',
              whiteSpace: 'nowrap',
            })}
          >
            <span>B</span>
            <span>{isEmpty ? '-' : `${bidPercent}%`}</span>
          </div>
          {/* Sell label */}
          <div
            className={hstack({
              position: 'absolute',
              right: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              gap: 8,
              textStyle: 'Text/S/Monospace/Strong',
              color: isEmpty ? 'content.default.level-2' : 'content.state.negative',
              whiteSpace: 'nowrap',
            })}
          >
            <span>{isEmpty ? '-' : `${askPercent}%`}</span>
            <span>S</span>
          </div>
        </div>
      </Tooltip.Trigger>
      <Tooltip.Content>
        <FormattedMessage id='Trade.r260413.Bid_ask_ratio_tooltip' />
      </Tooltip.Content>
    </Tooltip>
  );
};
